import { render, staticRenderFns } from "./RedeManage.vue?vue&type=template&id=20aacef1&scoped=true"
import script from "./RedeManage.vue?vue&type=script&lang=js"
export * from "./RedeManage.vue?vue&type=script&lang=js"
import style0 from "./RedeManage.vue?vue&type=style&index=0&id=20aacef1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20aacef1",
  null
  
)

export default component.exports